export const normalizeUrl = (url: string): string => {
  if (!url) return url
  // If already starts with http/https, leave as is
  if (/^https?:\/\//i.test(url)) {
    return url
  }
  // Otherwise, default to https://
  return `https://${url}`
}
